
eval("define(\'text!oroui/templates/widget-picker/widget-picker-filter-view.html\',[],function () { return \'<label>\\n    <i class=\"icon-search\"></i>\\n    <input type=\"text\" data-role=\"widget-picker-search\" value=\"<%=search %>\" placeholder=\"Enter keyword\" />\\n</label>\\n\';});\n\n//# sourceURL=/text!oroui/templates/widget-picker/widget-picker-filter-view.html");

